/* @flow */

import React from 'react'
import { connect } from 'react-redux'

import type {
  RootState,
  Dispatch,
  Poll,
  CheckedoutPoll,
  ExpertOpinion,
} from '../types'

import {
  selectCheckedoutPoll,
  checkoutExistingPoll,
} from '../stores/pollBuilderCheckedoutPoll'
import { checkoutExistingPollExpertOpinions } from '../stores/pollBuilderCheckedoutExpertOpinions'
import { selectExpertOpinionById } from '../stores/expertOpinionsStore'

import CheckedoutPollComponent from './CheckedoutPoll'

type Props = {
  originalPoll: Poll,
  checkedoutPoll: ?CheckedoutPoll,
  expertOpinions: Array<ExpertOpinion>,
  checkoutExistingPoll: (poll: Poll) => void,
  checkoutExistingPollExpertOpinions: (
    expertOpinions: Array<ExpertOpinion>
  ) => void,
}

type State = {
  checkedoutPoll: ?CheckedoutPoll,
}

type DispatchProps = {
  checkoutExistingPoll: (poll: Poll) => void,
}

class ExistingPollPageAfterFetch extends React.Component<Props, State> {
  componentDidMount() {
    this.props.checkoutExistingPoll(this.props.originalPoll)
    this.props.checkoutExistingPollExpertOpinions(this.props.expertOpinions)
  }

  render() {
    if (this.props.checkedoutPoll == null) {
      return null
    }
    return <CheckedoutPollComponent />
  }
}

function mapStateToProps(state: RootState, ownProps: Object): State {
  const poll = selectCheckedoutPoll(state)
  const originalPoll = ownProps.originalPoll
  const expertOpinions =
    !originalPoll || !originalPoll.expertOpinionIds
      ? []
      : originalPoll.expertOpinionIds.map(id => {
          const opinion = selectExpertOpinionById(state, id)
          if (opinion) {
            return opinion
          }
          return undefined
        })
  return {
    checkedoutPoll: poll,
    expertOpinions,
  }
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
  return {
    checkoutExistingPoll(poll: Poll) {
      dispatch(checkoutExistingPoll(poll))
    },
    checkoutExistingPollExpertOpinions: expertOpinions =>
      dispatch(checkoutExistingPollExpertOpinions(expertOpinions)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExistingPollPageAfterFetch)



// WEBPACK FOOTER //
// ./src/components/ExistingPollPageAfterFetch.js